import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clutchSecurity = defineConnector({
  identifier: "clutchSecurity",
  name: "Clutch Security",
  tagLine: "Non-human identity security",
  logo,
  protocol: "http",
  tags: ["security", "identity"],
  defaultUrlPattern: () => "https://api\\.clutch\\.security/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log into your [Clutch Security](https://clutch.security/) console and navigate to **Settings** > **API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Clutch Security API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clutch.security/v1/health",
  },
});
